import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Grid, Card, Image, Divider, List, Form, Button, Icon, Loader, Header, Popup } from 'semantic-ui-react';
import NetworkHandleInput from '../../components/network-handle-input';
import countries from '../../utils/helpers/countries';
import ValidatedEmailField from '../../components/validated-email-field';
import ThemeSelector from '../../themes/theme-selector';

const currentTheme = ThemeSelector.theme();
const gridStyle = {
  marginTop: 25,
  textAlign: 'center',
};

const imageStyle = {
  margin: '0 auto',
  display: 'block',
  // boxShadow: '0 0 10px #777',
};

const nameStyle = {
  padding: 10,
};

const descriptionStyle = {
  color: '#999',
};

const cardStyle = {
  paddingTop: 25,
  minHeight: 530,
};

const errorStyle = {
  paddingTop: 170,
  color: 'gray',
};

const DUMMY_THUMBNAIL = '/images/instagram-dummy-image.jpg';


class CreatorNewCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      isError,
      isLoading,
      instagramLoading,
      instagramLoaded,
      name, nameError,
      primarySocialHandle,
      thumbnail,
      country, countryError,
      displayName,
      email, emailError,
      isFormSubmitted,
    } = this.props;


    const displayThumbnail = thumbnail || DUMMY_THUMBNAIL;
    const instagramError = '';
    const instagramCount = 1000;

    const isInstagramLoaded = primarySocialHandle !== null;
    const isSignUpSetup = currentTheme.organisationId;

    return (
      <Grid container style={gridStyle}>
        <Grid.Row>
          <Grid.Column computer={5} only="computer" />
          <Grid.Column computer={6} mobile={16}>
            <Card fluid style={cardStyle}>
              {
                isLoading && <Loader active content="Loading..." />
              }
              {
                isError && (
                  <Header as="h4" icon style={errorStyle}>
                    <Icon name="frown" />
                  Something went wrong. Please try again later.
                  </Header>
                )
              }
              {
                !isSignUpSetup && (
                  <Header as="h4" icon style={errorStyle}>
                    <Icon name="frown" />
                  Sign Up is not Set up correct on this account.
                  </Header>
                )
              }
              {
                !isLoading && !isError && isSignUpSetup && (
                  <Card.Content>
                    <div style={{ height: 200 }}>
                      {
                        instagramLoading &&
                        <div style={{ paddingTop: 20 }}>
                          <Icon name="circle notched" loading size="massive" color="blue" />
                          <p style={{ color: 'grey', padding: 5, fontSize: '80%' }}>please wait while we find you...</p>
                        </div>
                      }
                      {
                        !instagramLoading &&
                        <Image
                          style={imageStyle}
                          className="circular"
                          size="small"
                          src={displayThumbnail}
                        />
                      }
                    </div>
                    <h3 style={nameStyle}>{displayName}</h3>
                    <p style={descriptionStyle}>{primarySocialHandle || '-'}</p>
                    <Divider />

                    <p style={{ paddingBottom: 10 }}>
                      Add your instagram handle/url below
                    </p>

                    <NetworkHandleInput
                      network="instagram"
                      error={instagramError}
                      value={primarySocialHandle}
                      loading={instagramLoading}
                      onChange={this.props.handleSocialChange}
                      count={instagramCount}
                      fluid
                    />
                  </Card.Content>
                )
              }

              {
                instagramLoaded &&
                <Card.Content style={{ textAlign: 'left' }}>

                  <p style={{ textAlign: 'center', paddingBottom: 10 }}>Great! Please fill in some basic details...</p>
                  <Form error onSubmit={this.props.onSubmit}>
                    <Form.Input
                      fluid
                      label="Name"
                      placeholder="Your real name"
                      name="name"
                      onChange={this.props.handleInputChange}
                      value={name}
                      required
                      error={nameError}
                    />

                    <Form.Dropdown
                      search
                      selection
                      label="Country"
                      value={country}
                      name="country"
                      options={countries}
                      error={countryError}
                      onChange={this.props.handleInputChange}
                      required
                    />

                    <Form.Input
                      label={'Email Address'}
                      value={email}
                      name="email"
                      onChange={this.props.handleEmailChanged}
                      error={emailError}
                      placeholder="Preferred contact email address"
                      required
                    />
                    <Divider />

                    <Form.Button disabled={isFormSubmitted} loading={isFormSubmitted} fluid color="flyt">
                      Create Account
                    </Form.Button>

                  </Form>


                </Card.Content>
              }
            </Card>
          </Grid.Column>
          <Grid.Column computer={5} only="computer" />
        </Grid.Row>
      </Grid>
    );
  }
}

CreatorNewCard.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
};

export default CreatorNewCard;



/** WEBPACK FOOTER **
 ** ./src/components/creator-new-card/index.js
 **/